import {JSX, MouseEvent} from "react";

import "./styles/select-footer.scss";

interface SelectFooterProps {
    onSelectAll: (e: MouseEvent<HTMLButtonElement>) => void;
    onClearAll: (e: MouseEvent<HTMLButtonElement>) => void;
}

export function SelectFooter({onSelectAll, onClearAll}: SelectFooterProps): JSX.Element {
    return (
        <div className="select-field__footer">
            <button type="button" onClick={onSelectAll} className="select-field__footer-btn">
                Select All
            </button>
            <button type="button" onClick={onClearAll} className="select-field__footer-btn">
                Clear All
            </button>
        </div>
    );
}
